export default "__VITE_ASSET__DgDikrFU__"